import { render, staticRenderFns } from "./ProductionSite.vue?vue&type=template&id=1fa7edf8&"
import script from "./ProductionSite.vue?vue&type=script&lang=js&"
export * from "./ProductionSite.vue?vue&type=script&lang=js&"
import style0 from "./ProductionSite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports